import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Sidebar.css';

const menuItems = [
  { id: 'add-phone', label: 'Telefon Ekle' },
  { id: 'our-phones', label: 'Telefonlarımız' },
  { id: 'add-address', label: 'Adres Ekle' },
  { id: 'our-address', label: 'Adreslerimiz' },
  { id: 'add-about', label: 'Hakkımızda Ekle' },
  { id: 'add-project', label: 'Proje Ekle' },
  { id: 'our-projects', label: 'Projelerimiz' },
  { id: 'add-service', label: 'Hizmet Ekle' },
  { id: 'our-services', label: 'Hizmetlerimiz' },
];

function Sidebar({ onMenuClick }: { onMenuClick: (id: string) => void }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false); // Menü başlangıçta kapalı

  const handleLogout = () => {
    Swal.fire({
      title: 'Çıkış yapmak istediğinizden emin misiniz?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, çıkış yap!',
      cancelButtonText: 'İptal',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Başarıyla çıkış yapıldı!', '', 'success').then(() => {
          navigate('/');
        });
      }
    });
  };

  return (
    <div className="flex">
      {/* Mobilde hamburger menü butonu, sağa konumlandırıldı */}
      <button
        className="md:hidden fixed top-4 right-4 z-50 bg-gray-800 text-white p-3 rounded focus:outline-none"
        onClick={() => setSidebarOpen(!isSidebarOpen)}
      >
        ☰
      </button>

      {/* Sidebar */}
      <div
        className={`bg-gray-800 w-64 min-h-screen fixed top-0 left-0 z-40 transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } md:relative md:translate-x-0 md:transition-none transition-transform duration-300`}
      >
        <nav className="flex flex-col py-4">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className="sidebar-button"
              onClick={() => {
                onMenuClick(item.id);
                if (window.innerWidth < 768) setSidebarOpen(false); // Mobilde menü otomatik kapanır
              }}
            >
              {item.label}
            </button>
          ))}
          <button
            className="sidebar-button bg-red-500 text-white hover:bg-red-600 mt-auto py-2"
            onClick={handleLogout}
          >
            Çıkış Yap
          </button>
        </nav>
      </div>

      {/* Sidebar açıkken ekranın geri kalanını karart */}
      {isSidebarOpen && window.innerWidth < 768 && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
}

export default Sidebar;
